<template>
    <div class="flex justify-between items-center">
        <BackButton v-if="props.showBackButton" @click="back" />
        <h1 class="text-2xl font-bold">{{ props.title }}</h1>
        <div class="flex items-center gap-2">
            <a v-for="(action, index) in props.actions" :key="index" @click="action.click" class="px-4 py-2 rounded-md hover:scale-105 transition-all duration-300 cursor-pointer" :class="action.class">{{ action.label }}</a>
        </div>
    </div>
</template>

<script setup>
import BackButton from '@/Components/BackButton.vue'
const props = defineProps({
    title: String,
    actions: Array,
    showBackButton: {
        type: Boolean,
        default: true
    }
})

const back = () => {
    window.history.back()
}
</script>